import React from 'react';
import { useTranslation } from 'next-i18next';

interface A11yExternalLinkProps {
  children: React.ReactNode;
}

const A11yExternalLink: React.FC<A11yExternalLinkProps> = ({ children }) => {
  const { t } = useTranslation('a11y');

  return (
    <>
      {children}
      <span className="visuallyhidden">{t('A11Y.EXTERNAL_LINKS_WARNING')}</span>
    </>
  );
};

export default A11yExternalLink;
